/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Neat_Legal_Reindeer_CherishInputs */

const fr_neat_legal_reindeer_cherish = /** @type {(inputs: Neat_Legal_Reindeer_CherishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une erreur est survenue lors de l'envoi du message`)
};

/**

* @param {Neat_Legal_Reindeer_CherishInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const neat_legal_reindeer_cherish = /** @type {((inputs?: Neat_Legal_Reindeer_CherishInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Neat_Legal_Reindeer_CherishInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_neat_legal_reindeer_cherish(inputs)
});